exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modeling-popover-wrapper[data-v-03400db6]{display:flex;flex-direction:row;justify-content:center;align-items:center}.icon-img[data-v-03400db6]{margin-top:4px;margin-left:4px;width:18px;height:18px}.modeling-title[data-v-03400db6]{margin-bottom:10px;font-size:14px;font-weight:500;color:#333}.modeling-content[data-v-03400db6]{display:flex;flex-direction:row;height:30px;font-size:14px;color:#666}.modeling-content span[data-v-03400db6]:nth-child(2){margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-03400db6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UserManage/UserManage/Components/ModelPopover.vue
// module id = 428
// module chunks = 0